import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { InstallationPosition } from '@enmon/commons';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { installationPositionTranslated } from '../../../Form/meter_details/constants';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface InstallationPositionSelectProps {
  value?: InstallationPosition;
  onChange?: (value: InstallationPosition) => void;
}

export const InstallationPositionSelect: VFC<InstallationPositionSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const installationPositionOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(InstallationPosition),
        suggestedValue: meterModelSuggestions?.installationPosition?.value,
        suggestedSelection: meterModelSuggestions?.installationPosition?.selection,
        labelFormatter: (value: InstallationPosition) => intl.formatMessage(installationPositionTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={installationPositionOptions}
      placeholder={<FormattedMessage {...messages.installationPositionPlaceholder} />}
      {...restProps}
    />
  );
};
